import { validationRuleMessageBuilder } from './validationRuleMessageBuilder';
export const createValidationRulesWithMessages = _ref => {
  let {
    required,
    noSpacesAtBeginning,
    noSpacesAtEnd,
    noPastDate,
    minLength,
    maxLength,
    min,
    integer,
    customValidation
  } = _ref;
  const builder = validationRuleMessageBuilder();
  if (required !== undefined) builder.withRequired(required);
  if (noSpacesAtBeginning) builder.withSpacesAtBeginningValidation();
  if (noSpacesAtEnd) builder.withSpacesAtEndValidation();
  if (noPastDate) builder.withNoPastDate();
  if (minLength !== undefined) builder.withMinLength(minLength);
  if (maxLength !== undefined) builder.withMaxLength(maxLength);
  if (min) builder.withMin(min);
  if (integer) builder.withIntegerValidation();
  if (customValidation) builder.withCustomValidation(customValidation);
  return builder.build();
};